export default class Typeform {
  constructor() {
    this.isEmbedScriptReady = false;

    this.typeformClickListener = this.typeformClickListener.bind(this);
    this.loadScriptCallback = this.loadScriptCallback.bind(this);
    this.makeTypeformPopup = this.makeTypeformPopup.bind(this);
  }

  install() {
    const typeformEls = document.querySelectorAll('.typeform-start-quiz');

    if (!typeformEls.length || this.isEmbedScriptReady) {
      return;
    }

    typeformEls.forEach((typeformEl) => {
      typeformEl.addEventListener('click', this.typeformClickListener);
    });
  }

  typeformClickListener(e) {
    e.preventDefault();

    const typeformEl = e.target;

    // If script is already loaded
    if (this.isEmbedScriptReady) {
      this.makeTypeformPopup(typeformEl);
      return;
    }

    this.addEmbedScript(typeformEl);
  }

  addEmbedScript(typeformEl) {
    // Load typeform scripts
    const scriptEl = document.createElement('script');
    scriptEl.src = 'https://embed.typeform.com/embed.js?typeform-welcome=0';
    document.body.appendChild(scriptEl);

    // Change button to Loading state
    typeformEl.textContent = 'Loading...';

    // Once loaded makeTypeform
    // Blocks further execution until its loaded
    scriptEl.onload = this.loadScriptCallback.bind(this, typeformEl);
  }

  loadScriptCallback(typeformEl) {
    typeformEl.textContent = 'Start quiz';
    this.makeTypeformPopup(typeformEl);
    this.isEmbedScriptReady = true;
  }

  // It's Typeform API, we don't need to test it
  /* istanbul ignore next */
  makeTypeformPopup(typeformEl) {
    if (!window.typeformEmbed) return;

    const formId = typeformEl.dataset.url.split(/\/to\//)[1];

    window.typeformEmbed.makePopup(
      typeformEl.dataset.url,
      {
        size: 70,
        hideHeaders: true,
        autoOpen: true,
        autoClose: 5,
      },
    );
  }
}
